import { HttpClient } from '@angular/common/http';
import {Portals} from '@qwyk/models';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '@qwyk/portals/environment';
import {map, take} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProofOfDeliveryService {
    constructor(private http: HttpClient) {
    }

    public getProofOfDelivery(parent: Portals.ParentEntity): Observable<Portals.ProofOfDelivery | null> {
        return this.http.get<{ data: Portals.ProofOfDelivery }>(
            `${environment.backendServer}/api/portals/${parent.domain}/${parent.type}/${parent.id}/proof-of-delivery`
        ).pipe(
            take(1),
            map(response => response.data)
        );
    }
}
